import script from "./RecomendedGameTable.vue?vue&type=script&setup=true&lang=js"
export * from "./RecomendedGameTable.vue?vue&type=script&setup=true&lang=js"

import "./RecomendedGameTable.vue?vue&type=style&index=0&id=e1ed62e8&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1ed62e8"]])

export default __exports__